import { API_ROOT, dispatchGetJSONAsync, completeJSONAsync } from './BaseApi';
import appdata from '../Services/appdata';

const CashFlow = () => {
  const getTop = async (selectedYears, DateKey, ReportingDateKey) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _selectedYears = selectedYears.slice();
    const allIndex = _selectedYears.indexOf('All');
    if (allIndex > -1) _selectedYears.splice(allIndex, 1);
    let _selectedDimDate = DateKey.slice();
    const _reportingDimDate = ReportingDateKey && ReportingDateKey.length
      ? ReportingDateKey.slice()
      : _selectedDimDate;
    const filter = { FYs: _selectedYears, DateKey: _reportingDimDate };

    queryParams += '?filter=' + JSON.stringify(filter);

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/projectedcashflow/${company_id}/${company_org_id}/topdata${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const getMiddle = async (selectedYears, DateKey, ReportingDateKey) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _selectedYears = selectedYears.slice();
    const allIndex = _selectedYears.indexOf('All');
    if (allIndex > -1) _selectedYears.splice(allIndex, 1);

    let _selectedDimDate = DateKey.slice();
    const _reportingDimDate = ReportingDateKey && ReportingDateKey.length
      ? ReportingDateKey.slice()
      : _selectedDimDate;
    const filter = {
      FYs: _selectedYears,
      DateKey: _selectedDimDate,
      ReportingDateKey: _reportingDimDate,
    };

    queryParams += '?filter=' + JSON.stringify(filter);

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/projectedcashflow/${company_id}/${company_org_id}/middledata${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const getBottom = async (selectedYears) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');
    
    let _selectedYears = selectedYears.slice();
    const allIndex = _selectedYears.indexOf('All');
    if (allIndex > -1) _selectedYears.splice(allIndex, 1);
    const filter = { FYs: _selectedYears };

    queryParams += '?filter=' + JSON.stringify(filter);

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/projectedcashflow/${company_id}/${company_org_id}/bottomdata${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };
  return {
    getTop,
    getMiddle,
    getBottom,
  };
};

export default CashFlow();
